import React from 'react';
import { makeStyles } from '@mui/styles';
import NotesImg from '../assets/images/notesimg.svg';
import delecticon from '../assets/images/delecticon.svg';
import pencilicon from '../assets/images/pencil.svg';
import profileicon from '../assets/images/profileIcon.svg';
import signOuticon from '../assets/images/signOutIcon.svg';
import chatedit from '../assets/images/chatedit.svg';
import calendardark from '../assets/images/calendardark.svg';
import filter from '../assets/images/Filter.svg';
import previewicon from '../assets/images/previewicon.svg';
import clockicon from '../assets/images/clockicon.svg';
import profileperson from '../assets/images/profileperson.svg';
import CheckListSvg from '../assets/images/check-list.svg';
import smallchat from '../assets/images/smallchat.svg';
import chaticonblue from '../assets/images/chaticon.svg';
import chaticon from '../assets/images/chaticonwhite.svg';
import chaticonblack from '../assets/images/chaticonblack.svg';
import chatdisabled from '../assets/images/chatdisabled.svg';
import Play from '../assets/images/Play.svg';
import celendaricon from '../assets/images/celendericon.svg';
import shareicon from '../assets/images/ShareIcon.svg';
import fluentwand from '../../../../assets/images/fluentwand.svg';
import profileiconFFF from '../assets/images/profileiconFFF.svg';
import addLevel from '../assets/images/addLevel.svg';
import circleAdd from '../assets/images/circleAdd.svg';
import uploadIcon from '../assets/images/upload.svg';
import iconview from '../assets/images/iconview.svg';
import thumbsupgreyimg from '../assets/images/thumbsupgreyimg.svg';
import answer from '../assets/images/answer.svg';
import downloadPdf from '../assets/images/download-Pdf.svg';
import exportPlan from '../assets/images/exportPlan.svg';
import excelFile from '../assets/images/microsoft-Excel-file.svg';
import blueCircleCalendar from '../assets/images/book.svg';
import Explore from '../assets/images/explore.svg';
import Chat1 from '../assets/images/chat1.svg';
import Community from '../assets/images/community.svg';
import CommunityOuter from '../assets/images/directory.svg';
import TasksList from '../assets/images/tasksList.svg';
import SetTimeData from '../assets/images/settimedata.svg';
import videoCallIconSvg from '../assets/images/videocallicon.svg';
// Plus Circle line
import PlusCirclePrimaryLine from '../assets/images/circleAdd.svg';
import PlusCircleBlueLine from '../assets/images/pluscircleblueline.svg';
import PlusCircleDisabled from '../assets/images/pluscircleDisabled.svg';
import PlusCircleSecondaryLine from '../assets/images/pluscirclesecondary.svg';
// Plus Circle Fill
import PlusCircleBlueFill from '../assets/images/pluscircle.svg';
import pluscircleblackFill from '../assets/images/pluscircleblack.svg';
import PlusCircleDisabledFill from '../assets/images/pluscircleDisabled.svg';
import ToDo from '../assets/images/ToDo.svg';
import userblack from '../assets/images/userblack.svg';
import VideoCall from '../assets/images/videoCall.svg';
import CalendarSvg from '../assets/images/calendar.svg';
import handshakesvg from '../assets/images/handshake.svg';
import videocallblack from '../assets/images/videocallblack.svg';
import ProfileImageSvg from '../assets/images/ProfileImageIcon.svg';
import VideoCallWhite from '../assets/images/whitevideocallicon.svg';
import BlueBackgroundNotes from '../assets/images/BlueBackgroundNotes.svg';
import GreenBackgroundChat from '../assets/images/GreenBackgroundChat.svg';
import YellowBackgroundVideo from '../assets/images/YellowBackgroundVideo.svg';

interface IconProps {
  size?: number | string;
  height?: number | string;
  width?: number | string;
  color?: string;
  onClick?: (event: React.MouseEvent<HTMLImageElement>) => void;
  style?: React.CSSProperties;
}

interface DisabledProps extends IconProps {
  disabled?: boolean;
}

interface TypeProps extends IconProps {
  type?: 'fill' | 'outline';
}

interface IconMap {
  default: string;
  disabled?: string;
  [color: string]: string | undefined;
}

const DEFAULT_SIZE = 20;

const useStyles = makeStyles({
  icon: (props: IconProps) => ({
    padding: '0',
    margin: '0',
    cursor: props.onClick ? 'pointer' : '',
    ...props.style // Spread the style prop here
  })
});

const Icon: React.FC<IconProps & { icon: string }> = ({
  size = DEFAULT_SIZE,
  height = size,
  width = size,
  icon,
  onClick,
  style
}) => {
  const classes = useStyles({ onClick, style });

  return <img src={icon} alt={'icon'} width={width} height={height} onClick={onClick} className={classes.icon} />;
};

/** Create Dynamic Icon */
const createDynamicIcon = (iconMap: IconMap): React.FC<DisabledProps> => {
  return ({ disabled, color, ...props }) => {
    const resolvedIcon = disabled ? iconMap.disabled : (color && iconMap[color]) || iconMap.default;

    // Fallback to default if the resolvedIcon is undefined
    const finalIcon = resolvedIcon || iconMap.default;

    return <Icon {...props} icon={finalIcon} />;
  };
};

/** Icons */
export const DeleteIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={delecticon} />;
export const EditIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={pencilicon} />;
export const ProfileIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={profileicon} />;
export const SignOutIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={signOuticon} />;
export const ChatEditIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={chatedit} />;
export const CalendardarkIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={calendardark} />;
export const FilterIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={filter} />;
export const PreviewIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={previewicon} />;
export const ClockIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={clockicon} />;
export const ProfilePersonIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={profileperson} />;
export const CheckListIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={CheckListSvg} />;
export const Smallchat: React.FC<IconProps> = (props) => <Icon {...props} icon={smallchat} />;
export const PlayIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={Play} />;
export const CalendarIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={celendaricon} />;
export const ShareIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={shareicon} />;
export const AddLevelIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={addLevel} />;
export const UploadIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={uploadIcon} />;
export const EyeIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={iconview} />;
export const ThumbsupFullGreyIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={thumbsupgreyimg} />;
export const AnswerIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={answer} />;
export const DownloadPdfIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={downloadPdf} />;
export const ExportPlanIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={exportPlan} />;
export const ExcelFileIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={excelFile} />;
export const BlueCircleCalendarIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={blueCircleCalendar} />;
export const ExploreIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={Explore} />;
export const Chat1Icon: React.FC<IconProps> = (props) => <Icon {...props} icon={Chat1} />;
export const CommunityIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={Community} />;
export const CommunityOutlineIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={CommunityOuter} />;
export const TasksListIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={TasksList} />;
export const SetTimeDataIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={SetTimeData} />;
export const CircleAddIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={circleAdd} />;
export const ToDoIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={ToDo} />;
export const DisabledVideoCall: React.FC<IconProps> = (props) => <Icon {...props} icon={VideoCall} />;
export const GreenBackgroundChatIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={GreenBackgroundChat} />;
export const YellowBackgroundVideoIcon: React.FC<IconProps> = (props) => (
  <Icon {...props} icon={YellowBackgroundVideo} />
);
export const BlueBackgroundNotesIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={BlueBackgroundNotes} />;
export const CalendarSvgIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={CalendarSvg} />;
export const NotesIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={NotesImg} />;
export const ProfileImageIcon: React.FC<IconProps> = (props) => <Icon {...props} icon={ProfileImageSvg} />;

/** Video call Icon */
export const VideoCallIcon = createDynamicIcon({
  default: videoCallIconSvg,
  disabled: VideoCall,
  blue: videoCallIconSvg,
  info: videoCallIconSvg,
  white: VideoCallWhite,
  primary: videocallblack
});

/** Chat Icon */
export const ChatIcon = createDynamicIcon({
  default: chaticonblue,
  disabled: chatdisabled,
  blue: chaticonblue,
  white: chaticon,
  primary: chaticonblack
});

/** User icon */
export const UserIcon = createDynamicIcon({
  default: profileiconFFF,
  disabled: ProfileImageSvg,
  white: profileiconFFF,
  primary: userblack
});

/** Add or Plus circle icon */
export const PlusCircleIcon = createDynamicIcon({
  disabled: PlusCircleDisabledFill,
  primary: pluscircleblackFill,
  info: PlusCircleBlueFill,
  default: PlusCircleBlueFill
});

/** Add or Handshake icon */
export const HandshakeIcon = createDynamicIcon({
  disabled: handshakesvg,
  primary: handshakesvg,
  info: handshakesvg,
  default: handshakesvg
});

/** Add circle icon */
export const AddCircleIcon: React.FC<TypeProps> = (props) => {
  const getIcon =
    props.color === 'primary'
      ? PlusCirclePrimaryLine
      : props.color === 'secondary'
      ? PlusCircleSecondaryLine
      : props.color === 'blue' && props.type === 'fill'
      ? PlusCircleBlueFill
      : props.color === 'gray3' && props.type === 'fill'
      ? PlusCircleDisabled
      : PlusCircleBlueLine;

  return <Icon {...props} icon={getIcon} />;
};
